module.exports = __webpack_public_path__ + "static/media/minus.88c9bb81.svg";